"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entryUrlReducer = void 0;
const entryUrl_1 = require("../actions/entryUrl");
const entryUrlReducer = (url = '', action) => {
    return action.type === entryUrl_1.SET_ENTRY_URL ? action.payload : url;
};
exports.entryUrlReducer = entryUrlReducer;
//# sourceMappingURL=entryUrl.reducer.js.map